import React from 'react';
import { FileText, Download, ChevronRight } from 'lucide-react';
import { csvFiles } from '../mock/mock';

const CSVSecondary = () => {
  return (
    <section className="rounded-2xl border border-white/5 bg-black/20 overflow-hidden">
      <div className="px-4 py-2.5 flex items-center gap-2 border-b border-white/5 bg-white/[0.02]">
        <FileText className="h-3.5 w-3.5 text-white/50" />
        <h3 className="font-mono text-white/70 text-xs uppercase tracking-widest">CSV récents</h3>
        <span className="ml-auto text-[9px] font-mono text-white/40">{csvFiles.length} fichiers · 15j</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-0 px-2 py-1.5 max-h-[180px] overflow-y-auto">
        {csvFiles.map((f, i) => (
          <div key={i} className="flex items-center gap-1.5 px-2 py-1 rounded hover:bg-white/[0.03] transition-colors group cursor-pointer">
            <ChevronRight className="h-3 w-3 text-white/25 group-hover:text-cyan-400 group-hover:translate-x-0.5 transition-all flex-shrink-0" />
            <p className="font-mono text-white/60 text-[10px] truncate flex-1">{f.name}</p>
            <p className="font-mono text-[9px] text-white/40 whitespace-nowrap">{f.size}</p>
            <Download className="h-3 w-3 text-white/20 group-hover:text-cyan-400 transition-colors flex-shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default CSVSecondary;
